import { render, staticRenderFns } from "./RegionDetalle.vue?vue&type=template&id=08bda9ec&scoped=true"
import script from "./RegionDetalle.vue?vue&type=script&lang=js"
export * from "./RegionDetalle.vue?vue&type=script&lang=js"
import style0 from "./RegionDetalle.vue?vue&type=style&index=0&id=08bda9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bda9ec",
  null
  
)

export default component.exports